var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClass,attrs:{"id":"app"}},[(_vm.$route.meta.activeTabId)?_c('Footer',{attrs:{"activeId":_vm.$route.meta.activeTabId}}):_vm._e(),_vm._v(" "),(_vm.$route.meta.hasBanner)?_c('Header'):_vm._e(),_vm._v(" "),_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('float-audio')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1de60d0a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 